import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionsService } from '../services/permissions.service';

export const pageMappingGuard: CanActivateFn = async (route, _state) => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  const pageMapping = route.data['pageMapping'] as string | undefined;

  if (!pageMapping) {
    return true;
  }

  // Flag setada pelo APP_INITIALIZER antes do bootstrap (não usamos window.location.search
  // porque a URL pode já ter sido limpa via history.replaceState nesse ponto). Single-use.
  if (sessionStorage.getItem('__pwa_post_login_bypass')) {
    sessionStorage.removeItem('__pwa_post_login_bypass');
    console.log('[pageMappingGuard] 🔑 Redirect pós-login detectado — liberando navegação inicial sem verificar permissões.');
    return true;
  }

  await permissionsService.ensureLocalPermissionsLoaded();
  const status = permissionsService.getRoutePermissionStatus(pageMapping);
  if (status === 'allowed') {
    return true;
  }
  if (status === 'pending') {
    // Bootstrap de permissões ainda em andamento; a próxima validação decide allowed/denied.
    return true;
  }
  return router.parseUrl('/sem-permissao');
};

